module.exports = function() {
  return new Worker(__webpack_public_path__ + "574427ba6da271c1e2ba.worker.js");
};